// extracted by mini-css-extract-plugin
module.exports = {"inactiveDot":"NodeMetric__inactiveDot___hlyEN","errorDot":"NodeMetric__errorDot___MBdSh","warningDot":"NodeMetric__warningDot___6N03y","okDot":"NodeMetric__okDot___+UaZw"};